import clsx from 'clsx';
import DashboardBreadcrumbs from 'components/Common/DashboardBreadcrumbs/DashboardBreadcrumbs';
import PageTitle from 'components/Common/PageTitle/PageTitle';
import { useMergedStyles } from 'hooks/useMergedStyles';
import useWindowSize from 'hooks/useWindowSize';
import { FC, ReactElement } from 'react';
import { Styles } from 'types/styles';

import styles from '../DashboardPageWrapper.module.scss';

type Props = {
  newStyles?: Styles;
  pageTitleText?: string;
  pageDescriptionText?: string;
  children: ReactElement;
  breadcrumbsItems?: {
    path: string;
    link?: string;
  }[];
};

const DashboardPageWrapperContent: FC<Props> = ({
  newStyles = {},
  pageTitleText = '',
  pageDescriptionText = '',
  children,
  breadcrumbsItems = [],
}) => {
  const mergedStyles = useMergedStyles(styles, newStyles);
  const windowSize = useWindowSize();
  const isMobileView = windowSize.width < 800;

  return (
    <div className={mergedStyles['dashboard-page-wrapper-content-container']}>
      <div className={mergedStyles['dashboard-page-wrapper-content-wrapper']}>
        {isMobileView && (
          <div className={mergedStyles['dashboard-page-wrapper-breadcrumbs-wrapper']}>
            <DashboardBreadcrumbs breadcrumbsItems={breadcrumbsItems} />
          </div>
        )}
        <div
          className={clsx(mergedStyles['dashboard-page-wrapper-content-title-wrapper'], {
            [mergedStyles.active]: pageTitleText || pageDescriptionText,
          })}
        >
          {pageTitleText && <PageTitle text={pageTitleText} newStyles={mergedStyles} />}
          {pageDescriptionText && (
            <div
              className={mergedStyles['dashboard-page-wrapper-content-title-description']}
            >
              {pageDescriptionText}
            </div>
          )}
        </div>

        <div className={mergedStyles['dashboard-page-content-route-wrapper']}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardPageWrapperContent;
